import { useReactiveVar } from '@apollo/client';
import { useNavigate, useParams } from '@tanstack/react-router';
import type React from 'react';

import DeleteDialog from 'src/components/dialogs/DeleteDialog';
import HiresDialog from 'src/components/dialogs/HiresDialog';
import LibraryDownloadDialog from 'src/components/dialogs/LibraryDownloadDialog';
import ShareDialog from 'src/components/dialogs/ShareDialog';
import { HOME_PATH, LIBRARY_PAGE, REMOVE_FROM_GALLERY_SLUG } from 'src/constants';
import RemoveGalleryItem from 'src/Gallery/RemoveGalleryItem';
import TopNavBar from 'src/HomePage/TopNavBar/TopNavBar';
import viewStateVar from 'src/store/viewState';
import { OpenSearchNavigationWrapper } from './MediaNavWrappers';
import MediaPage from './MediaPage';

// New component to handle opensearch data fetching
export default function WrappedLibraryMedia(): React.JSX.Element {
  const viewState = useReactiveVar(viewStateVar);
  const params = useParams({ strict: false });
  const galleryId = (params as { galleryId?: string }).galleryId;
  const navigate = useNavigate();

  return (
    <>
      <TopNavBar currentPage={LIBRARY_PAGE} simple={false} />
      <OpenSearchNavigationWrapper>
        <MediaPage />
      </OpenSearchNavigationWrapper>
      <ShareDialog />
      <LibraryDownloadDialog isOpen={!!viewState.libraryDownloadDialog} />
      <DeleteDialog refetchQ="" />
      <HiresDialog isOpen={!!viewState.hiresDialog} isSingleAssetOnMediaPage={true} />
      <RemoveGalleryItem
        isOpen={viewState.globalAction === REMOVE_FROM_GALLERY_SLUG && !!galleryId}
        onClose={() => {
          viewStateVar({ ...viewState, globalAction: null });
          navigate({ to: `${HOME_PATH}/gallery/${galleryId}` });
        }}
      />
    </>
  );
}
